import React from 'react';
import { withRouter, MujiLink } from '@souche-f2e/muji';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Detail from '@/components/Dashboard/detail';
import Menu from '@/components/Dashboard/app_menu';
import HiddenButton from '@/components/Dashboard/hidden_button';
import styles from './index.module.less';

import { Modal } from 'antd';

function findAppFromUser(appKey, user = {}) {
  const appList = user.appList || [];
  const stableInfo = user.stableInfo || {};
  const stableAppList = stableInfo.appList || [];

  let appEnv = 'prod';
  for (const app of appList) {
    if (app && app.appKey === appKey) {
      app.appEnv = appEnv;
      return app;
    }
  }

  appEnv = 'stable';

  for (const app of stableAppList) {
    if (app && app.appKey === appKey) {
      app.appEnv = appEnv;
      return app;
    }
  }
  
  return null;
}

@withRouter
class App extends React.Component {
  constructor() {
    super();
  }

  componentWillMount() {
    dispatch.user.LOAD_USER();
    dispatch.user.userinfo();

    setTimeout(() => {
      const { user = {} } = this.props;
      const appKey = this.props.router.history.current.params.key;

      dispatch.traffic.getAppTraffic(appKey);
    }, 0);
  }

  buildTrafficCycleValue = (cycle) => {
    let value = '';
    switch (cycle) {
      case 1:
        value = '天'
        break;
      case 2:
        value = '时'
        break;
      case 3:
        value = '分'
        break;
      case 4:
        value = '秒'
        break;
    }
    return value
  }

  refreshTraffic(appKey) {
    dispatch.traffic.getAppTraffic(appKey);
  }

  resetTrafficConfirm(params) {

    Modal.confirm({
      title: '是否确定要重置该流量',
      content: <p> </p>,
      okText: '确认',
      cancelText: '取消',
      onCancel: () => { },
      onOk: () => dispatch.traffic.resetTraffic(params),
    });
  }

  showTrafficConfig = () => {

    const { appTraffic } = this.props;

    if (!appTraffic || JSON.stringify(appTraffic) === '{}') {
      return '暂无配置';
    }

    // 显示后台返回的 流量配置信息， 并提供一个重置流量 的操作链接
    return (
      <div>
        <span>{appTraffic.trafficLimit} 次/{this.buildTrafficCycleValue(appTraffic.trafficCycle)} </span>
        <span style={{ 'marginLeft': '20px' }}> 已使用量: {appTraffic.trafficUsed}</span>
        <span style={{ 'marginLeft': '20px' }}>
          <a
            style={{ color: 'rgb(138,43,226)' }}
            onClick={() =>
              this.refreshTraffic(appTraffic.appKey)
            }
          >
            用量刷新
          </a>
        </span>
        <span style={{ 'marginLeft': '20px' }}>
          <a
            style={{ color: 'rgb(138,43,226)' }}
            onClick={() =>
              this.resetTrafficConfirm({
                type: 'app',
                appKey: appTraffic.appKey
              })
            }
          >
            重置流量控制
          </a>
        </span>
      </div>
    )
  }

  render() {
    let { user = {}, isLogin } = this.props;

    user = user || {};

    // 检查 login 状态
    if (isLogin === false) {
      this.props.router.push('/signIn');
      return;
    }

    const appKey = this.props.router.history.current.params.key;

    const app = findAppFromUser(appKey, user);

    if (!app) return <div>app 不存在；非法的 appKey{appKey}</div>

    const items = [
      ['APP 名称', app.name],
      [ 'APP 环境', app.appEnv === 'prod' ? '预发 / 生产' : 'Stable / 测试' ],
      ['APP CODE', app.code],
      ['商铺 CODE', app.shopCode],
      ['应用描述', app.description],
      ['APP KEY', app.appKey],
      ['APP SECRET', <HiddenButton value={app.appSecret} />],
      ['回调 URL', app.callbackUrl],
    ];

    const groups = app.apiGroupPermissionList;

    const groupItems = groups.map(group => [group.apiGroupName, (
      <div>
        <span>{group.apiGroupDescription}</span>
        <MujiLink style={{
          borderLeft: '4px solid #42b983',
          paddingLeft: '12px',
          marginLeft: '12px',
          color: '#1890ff'
        }} to={`/documents/${app.appEnv === 'prod' ? 'docs' : 'stable_docs'}/group/${group.apiGroupId}`}>
          查看文档
        </MujiLink>
      </div>
    )])

    const trafficItems = [
      ['状态', app.isOpenTrafficControl ? '已开启' : '暂未开启'],
      ['配置', this.showTrafficConfig(app.appKey)]
    ]

    return (
      <div className={styles.detail}>
        <div className={styles.context}>
          {/* <div className={styles.menu}>
            <MujiLink className={styles.callback} to="/">返回 APP 列</MujiLink>
          </div> */}
          <div className={styles.menu}>
            <div className={styles.title}>{app.name}</div>
          </div>
          <Menu></Menu>
        </div>

        <div style={{ backgroundColor: 'rgb(240, 243, 245)', flex: 1 }} >
          <Detail items={items} title={'APP / 应用'} />
          <Detail items={trafficItems} title={'APP 流量控制'} />
          <Detail items={groupItems} title={'订阅的 API 组'} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = state.user;
  const traffic = state.traffic;
  return {
    hasUserInfoCache: user.hasUserInfoCache,
    user: user.user,
    isLogin: user.isLogin,
    appTraffic: traffic.appTraffic
  }
}

export default connect(mapStateToProps)(App);
